module.exports = __webpack_public_path__ + "static/media/kazoo.e96658b3.svg";